import React, { Component, Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Helmet } from "react-helmet";
import PickForm from './components/PickForm';
import LetterOfAppeal from './components/LetterOfAppeal';
import LetterOfMedicalNecessity from './components/LetterOfMedicalNecessity';
import FormularyLookup from './components/FormularyLookup';
import InsuranceCoverageLookup from './components/InsuranceCoverageLookup';
import ShortEnrollment from './components/ShortEnrollment';
import ShortEnrollmentButtons from './components/ShortEnrollmentButtons';
import PAMLookup from './components/PAMLookup';
import ScrollToAnchor from './components/hooks/ScrollToAnchor';
import TreatmentForm from './components/TreatmentForm';
//import SignupForm from './components/SignupForm';

class App extends Component {
  render() {
    const pathName = window.pathName;
    
    return (
      <Fragment>
        <Helmet>
          <title>Acadia LTC</title>
        </Helmet>
          <BrowserRouter>
            <Switch>   
              <Route location={ pathName } exact path="/" component={ PickForm } />
              <Route location={ pathName } exact path="/pam" component={ PAMLookup } />
              <Route location={ pathName } exact path="/scroll-to-anchor" render={(props) => (<ScrollToAnchor {...props} type={'blue'} />)} />
              <Route location={ pathName } exact path="/letter-of-appeal" component={ LetterOfAppeal } />
              <Route location={ pathName } exact path="/letter-of-medical-necessity" component={ LetterOfMedicalNecessity } />
              <Route location={ pathName } exact path="/formulary-lookup" component={ FormularyLookup } />
              <Route location={ pathName } exact path="/insurance-coverage-lookup" component={ InsuranceCoverageLookup } />
              <Route location={ pathName } exact path="/enrollment-short" component={ ShortEnrollment } />
              <Route location={ pathName } exact path="/enrollment-short-buttons" component={ ShortEnrollmentButtons } />
              <Route location={ pathName } exact path="/treatment-ltc-form" component={ TreatmentForm } />
              {/* <Route location={ pathName } exact path="/sign-up" component={SignupForm} /> */}
            </Switch>
          </BrowserRouter>
      </Fragment>
    );
  }
}

export default App;